
const Solutions = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Unsere Lösungen</h1>
      <p>Entdecken Sie maßgeschneiderte Lösungen für Ihr Unternehmen.</p>
    </div>
  );
};

export default Solutions;
